import { Dropdown, Button } from "antd";
import { useMsal } from "@azure/msal-react";
import { DownOutlined } from "@ant-design/icons";
import { loginRequest } from "../../../../authConfig";
import {setItem} from "../../../../utility/localStorageControl";

export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = (loginType) => {
    if (loginType === "popup") {
      instance.loginPopup(loginRequest)
          .then((response) => {
            // Store the access token (or any other key-value pair) in localStorage
           setItem("isMicrosoftLoggedIn", true);
           setTimeout(() => {
             window.location.reload();
           }, 1500)
          })

          .catch((e) => {
        console.log(e);
      });
    }

    // else if (loginType === "redirect") {
    //   instance.loginRedirect(loginRequest)
    //       .then((response) => {
    //         // Store the access token (or any other key-value pair) in localStorage
    //        setItem("isMicrosoftLoggedIn", true);
    //         console.log("Login successful via redirect:", response);
    //       })
    //
    //       .catch((e) => {
    //     console.log(e);
    //   });
    // }
  };

  // Dropdown menu items with Ant Design
  const menuItems = [
    {
      key: "popup",
      label: (
        <button
          onClick={() => handleLogin("popup")}
          className="w-full text-left hover:bg-blue-100 px-4 py-1"
        >
          Sign in using Popup
        </button>
      ),
    },
    // {
    //   key: "redirect",
    //   label: (
    //     <button
    //       onClick={() => handleLogin("redirect")}
    //       className="w-full text-left hover:bg-blue-100 px-4 py-1"
    //     >
    //       Sign in using Redirect
    //     </button>
    //   ),
    // },
  ];

  return (
    <div className="mx-auto">
      <Dropdown
        menu={{
          items: menuItems,
        }}
        trigger={["click"]}
        placement="bottomLeft"
      >
        <Button
          type="primary"
          icon={<DownOutlined />}
          className="bg-blue-600 hover:bg-blue-700 text-white"
        >
          Sign In
        </Button>
      </Dropdown>
    </div>
  );
};
